import alex from './runLengthEncodingAlex.json';
import _ from 'lodash';
const BUFF_COLS = 50,
  BUFF_ROWS = 38;

const decodeBuffer = (encoding: [number, number][]) => {
  const decoded = [];
  for (const [value, num] of encoding) {
    for (let i = 0; i < num; ++i) {
      decoded.push(value);
    }
  }
  return decoded;
};

// Arranges a list of items that can be individually considered as light/dark pixels into a
// picture of Alexandr Wang.
export function matching<T>(items: T[], isDark: (item: T) => boolean) {
  const buff = decodeBuffer(alex as [number, number][]);

  // Step 1: group into row-column approximating our original dimensions.
  const ROW_LEN = Math.round(Math.sqrt((items.length * BUFF_COLS) / BUFF_ROWS));
  const ROW_COUNT = Math.ceil(items.length / ROW_LEN);
  const rect = [];
  let ind = 0;
  for (let i = 0; i < ROW_COUNT; ++i) {
    const row = [];
    for (let j = 0; j < ROW_LEN && ind < items.length; ++j, ++ind) {
      row.push(items[ind]);
    }
    rect.push(row);
  }

  // Step 2: determine closest pixel in reference image for each item. Extract list of “on” slots.
  const picture_on_coords = [];
  const picture_off_coords = [];
  for (let i = 0; i < rect.length; ++i) {
    for (let j = 0; j < rect[i].length; ++j) {
      const col = Math.floor((j / ROW_LEN) * BUFF_COLS);
      const row = Math.floor((i / ROW_COUNT) * BUFF_ROWS);
      const isOn = !!buff[row * BUFF_COLS + col];
      if (isOn) {
        picture_on_coords.push([i, j]);
      } else {
        picture_off_coords.push([i, j]);
      }
    }
  }

  // Step 3: Create list of preferred assignment orders. First shuffle the “on” slots, then shuffle the “off” slots.
  const preferredPictureAssignmentSlotOrder = _.shuffle(picture_on_coords.slice()).concat(
    _.shuffle(picture_off_coords.slice()),
  );

  // Step 4: Order available pixels. First all the “ons” in any order, then all the “offs” in any order. Create matching from this list.
  const pixels = items.filter(isDark).concat(items.filter(i => !isDark(i)));
  const frame: (null | T)[][] = [];
  let iterIndex = 0;
  for (let i = 0; i < ROW_COUNT; ++i) {
    const row = [];
    for (let j = 0; j < ROW_LEN && iterIndex < items.length; ++j, ++iterIndex) {
      row.push(null);
    }
    frame.push(row);
  }
  for (let i = 0; i < items.length; ++i) {
    const item = pixels[i];
    const loc = preferredPictureAssignmentSlotOrder[i];
    frame[loc[0]][loc[1]] = item;
  }
  return frame;
}
